import { Controller } from "@hotwired/stimulus"
import { canSubmit, pageState, selectionLabel } from "../lib/bulk_select_logic"

// The company list's selection (companies/_bulk_owner): a checkbox per row, one for the page, and "Všetky
// firmy filtra", which sets the rows aside. Without JavaScript the checkboxes are sent as they are and the
// server decides (CompanyAssignmentsController).
export default class extends Controller {
  static targets = ["row", "page", "all", "count", "submit"]
  static values = { cap: { type: Number, default: 5000 } }

  connect() {
    this.refresh()
  }

  togglePage() {
    const checked = this.pageTarget.checked
    this.rowTargets.forEach((row) => { row.checked = checked })
    this.refresh()
  }

  refresh() {
    const all = this.hasAllTarget && this.allTarget.checked
    const ticked = this.rowTargets.filter((row) => row.checked).length
    this.rowTargets.forEach((row) => { row.disabled = all })
    if (this.hasPageTarget) {
      const state = pageState(ticked, this.rowTargets.length)
      this.pageTarget.checked = state.checked
      this.pageTarget.indeterminate = state.indeterminate
      this.pageTarget.disabled = all
    }
    if (this.hasCountTarget) this.countTarget.textContent = selectionLabel(ticked, all, this.capValue)
    if (this.hasSubmitTarget) this.submitTarget.disabled = !canSubmit(ticked, all)
  }
}
